import { createEventEmitter, EventEmitter } from '@quickplay/foundation';
import { AdFrequencyEvent, AdFrequencyEventPublisher } from './types';

const EVENT_NAME = 'ad-frequency-event';
const eventEmitter: EventEmitter = createEventEmitter();

export const adFrequencyEventPublisher: AdFrequencyEventPublisher = {
  publish(event: AdFrequencyEvent): void {
    eventEmitter.publish(EVENT_NAME, event);
  },
};

export const subscribeToAdFrequencyEvents = (listener: (event: AdFrequencyEvent) => void): (() => void) => {
  eventEmitter.subscribe(EVENT_NAME, listener);
  return () => eventEmitter.unsubscribe(EVENT_NAME, listener);
};